import { useState, useCallback, useMemo } from 'react';

    function productCalculation(parameters) {
        let {
            metalRate,
            purity,
            inputPurity,
            metal_weight,
            deliveryCharges,
            packingCharges,
            makingCharges,
            hallmarkCharges,
            otherCharges,
            deliveryDiscountPercentage,
            packingDiscountPercentage,
            makingDiscountPercentage,
            gstDeliveryPercentage,
            gstPackingPercentage,
            gstMakingPercentage,
            taxPercentage,
            productDiscountPercentage,
            makingPercentage,
            isChecked
        } = parameters;

        if (!metal_weight || metal_weight <= 0) {
            return {
                productRate: 0,
                productCost: 0,
                discountedProductCost: 0,
                taxAmount: 0,
                finalProductPriceWithTax: 0,
                finalDeliveryCharges: 0,
                finalPackingCharges: 0,
                finalMakingCharges: 0,
                hallmarkCharges: 0,
                otherCharges: 0,
                finalPrice: 0,
            };
        }

        const productRate = (metalRate / purity) * inputPurity;
        const productCost = metal_weight * productRate;

        const discountedProductCost = productCost - (productCost * productDiscountPercentage) / 100;

        // Calculate making charges with GST
        //- let isPercentage = true
  
        let actualMakingCharges = isChecked
            ? (productCost * makingPercentage) / 100
            : makingCharges;

        // Calculate making charges with GST
        const discountedMakingCharges = actualMakingCharges - (actualMakingCharges * makingDiscountPercentage) / 100;
        const gstOnMaking = (discountedMakingCharges * gstMakingPercentage) / 100;
        const finalMakingCharges = discountedMakingCharges + gstOnMaking;

        // Calculate delivery charges with GST
        const discountedDeliveryCharges = deliveryCharges - (deliveryCharges * deliveryDiscountPercentage) / 100;
        const gstOnDelivery = (discountedDeliveryCharges * gstDeliveryPercentage) / 100;
        const finalDeliveryCharges = discountedDeliveryCharges + gstOnDelivery;

        // Calculate packing charges with GST
        const discountedPackingCharges = packingCharges - (packingCharges * packingDiscountPercentage) / 100;
        const gstOnPacking = (discountedPackingCharges * gstPackingPercentage) / 100;
        const finalPackingCharges = discountedPackingCharges + gstOnPacking;
        const safeHallmarkCharges = Number(hallmarkCharges) || 0;
        const safeOtherCharges = Number(otherCharges) || 0;

        // Calculate taxable amount
        let taxableAmount = discountedProductCost + safeHallmarkCharges + safeOtherCharges;
        if (gstMakingPercentage === 0) taxableAmount += discountedMakingCharges;
        if (gstDeliveryPercentage === 0) taxableAmount += discountedDeliveryCharges;
        if (gstPackingPercentage === 0) taxableAmount += discountedPackingCharges;

        // Apply tax
        const taxAmount = (taxableAmount * taxPercentage) / 100;

        // Final price calculation
        const finalPrice = taxableAmount + taxAmount +
            (gstMakingPercentage > 0 ? finalMakingCharges : 0) +
            (gstDeliveryPercentage > 0 ? finalDeliveryCharges : 0) +
            (gstPackingPercentage > 0 ? finalPackingCharges : 0);

        return {
            productRate: parseFloat(productRate.toFixed(2)) || 0,
            productCost: parseFloat(productCost.toFixed(2)) || 0,
            discountedProductCost: parseFloat(discountedProductCost.toFixed(2)) || 0,
            taxAmount: parseFloat(taxAmount.toFixed(2)) || 0,
            finalProductPriceWithTax: parseFloat((taxableAmount + taxAmount).toFixed(2)) || 0,
            finalDeliveryCharges: parseFloat(finalDeliveryCharges.toFixed(2)) || 0,
            finalPackingCharges: parseFloat(finalPackingCharges.toFixed(2)) || 0,
            finalMakingCharges: parseFloat(finalMakingCharges.toFixed(2)) || 0,
            hallmarkCharges: parseFloat(safeHallmarkCharges.toFixed(2)) || 0,
            otherCharges: parseFloat(safeOtherCharges.toFixed(2)) || 0,
            finalPrice: parseFloat(finalPrice.toFixed(2)) || 0,
        };
    }

export function useProductCalculation(initialParams) {
  const [params, setParams] = useState(initialParams);

  const calculationResult = useMemo(() => {
    return productCalculation(params);
  }, [params]);

  const updateCalculation = useCallback((newParams) => {
    setParams((prev) => ({ ...prev, ...newParams }));
  }, []);

  return {
    calculationResult,
    updateCalculation,
    currentParams: params
  };
}
